import Header from "../header"
import "./index.css"
import TaskBar from "../taskbar";
import CopyRight from "../copyright";

const CountrieNez = () => {

    return (
        <>
        <Header />
        <div className="container-head">
          <h1>Why Choose New Zealand as Your Study Destination?</h1>  
          <p>New Zealand presents a world-class education system, a unique and stunning natural environment, and a welcoming, multicultural society for international students.  </p>
        <p>Key Advantages:  </p>
        <ul>
           <li> World-Class Education System  </li>
           <li> Globally Recognized Qualifications  </li>
           <li>Clear Post-Study Work and PR Pathways  </li>
           <li>Safe, Peaceful, and Multicultural Society  </li>
           <li> High Quality of Life and Stunning Landscapes </li>
           <li>Work While Studying to Gain Experience  </li>
           <li> Affordable Tuition and Living Costs</li>
        </ul>

        <hr />
        <table>
            <caption>Quick Facts About New Zealand</caption>
            <thead>
                <tr>
                    <th>Category</th>
                    <th>Details</th>
                </tr>
            </thead>
                <tr>
                    <td>Capital </td>
                    <td>Wellington </td>
                </tr>
                <tr>
                    <td>Currency</td>
                    <td>New Zealand Dollar (NZD) </td>
                </tr>
                <tr>
                    <td>Population</td>
                    <td>Approx. 5 million </td>
                </tr>
                <tr>
                    <td>Official Languages</td>
                    <td>English, Māori </td>
                </tr>
                <tr>
                    <td>Major Intake </td>
                    <td>February & July  </td>
                </tr>
                <tr>
                    <td>Universities </td>
                    <td>8 Government-Funded, Top-Ranked Universities  </td>
                </tr>
                <tr>
                    <td>Time Zones</td>
                    <td>New Zealand Standard Time (NZST)</td>
                </tr>
                <tr>
                    <td>Popular Cities</td>
                    <td>Auckland, Wellington, Christchurch, Hamilton, Dunedin</td>
                </tr>
        </table>
        

        <hr />

        <h2>New Zealand’s Education Landscape </h2>

         <p>New Zealand offers an education system that emphasizes practical learning, academic excellence, and global employability. </p>
         
        <p>Types of Institutions</p>
        <ul>
            <li>Universities: 8 public universities offering Bachelor’s, Master’s, and Doctoral degrees.  </li>           
            <li>Institutes of Technology and Polytechnics (ITPs): Career-oriented vocational and technical programs. </li>
            <li>Private Training Establishments (PTEs): Specialized programs in Business, Hospitality, IT, etc. </li>
        </ul>  
        
        <table>
            <thead>
                <tr>
                    <th>Qualification</th>
                    <th>NZQF Level</th>
                    <th>Duration</th>
                </tr>
            </thead>
                <tr>
                    <td>Certificate </td>
                    <td>4-5</td>
                    <td>6–12 months</td>
                </tr>
                <tr>
                    <td>Diploma </td>
                    <td>5-6 </td>
                    <td>1–2 years </td>
                </tr>
                <tr>
                    <td>Bachelor’s Degree</td>
                    <td>7</td>
                    <td>3 years</td>
                </tr>
                <tr>
                    <td>Graduate Diploma</td>
                    <td>7 </td>
                    <td>1 year </td>
                </tr>
                <tr>
                    <td>Master’s Degree  </td>
                    <td>9</td>
                    <td>1–2 years</td>
                </tr>
                <tr>
                    <td>Doctorate (Ph.D.) </td>
                    <td>10  </td>
                    <td>3–4 years</td>
                </tr>
                </table>
                <hr/>
                <h2>Key Features of New Zealand’s Education System </h2>
                 <ul>
                    <li>NZQA Accreditation: All courses meet strict quality assurance.</li>
                    <li>NZQF Framework: Clear qualification levels from Certificates to Ph.D. </li>
                    <li>Industry-Integrated Learning: Strong focus on internships and real-world projects.</li>
                    <li>Post-Study Work Pathways: Up to 3 years after graduation.</li>
                 </ul>
                <p>Alternate English Tests Accepted: PTE Academic, TOEFL iBT</p>
            <hr />
            <h2> Study Intakes and Entry Requirements</h2>
             
             <table>
                <thead>
                    <tr>
                        <th>Intake</th>
                        <th>Timeline </th>
                    </tr>
                </thead>
                <tr>
                    <td>February</td>
                    <td>Main Intake (February–June) </td>
                </tr>
                <tr>
                    <td>July </td>
                    <td>Secondary Intake (July–November)</td>
                </tr>
                <tr>
                    <td>Rolling/Monthly</td>
                    <td> Private Colleges (PTEs) flexible admissions</td>
                </tr>
             </table>

             <table>
                <thead>
                    <tr>
                        <th>Program</th>
                        <th>Academic Requirements </th>
                        <th>IELTS</th>
                        <th>TOEFL</th>
                        <th>PTE</th>
                    </tr>
                </thead>
                <tr>
                    <td>Undergraduate</td>
                    <td>10+2 or equivalent</td>
                    <td>6.0 (no band 5.5) </td>
                    <td> 60–80 </td>
                    <td>50–58</td>
                </tr>
                <tr>
                    <td>Postgraduate</td>
                    <td>Bachelor’s Degree (3–4 years)</td>
                    <td> 6.5 (no band 6.0)</td>
                    <td>80–90</td>
                    <td>58–64 </td>
                </tr>
                <tr>
                    <td>Diploma/Certificate</td>
                    <td>Class 12 or equivalent</td>
                    <td>5.5–6.0 </td>
                    <td>Varies </td>
                    <td>Varies </td>
                </tr>
             </table>
             <hr />
           <h2> Cost of Studying in New Zealand </h2>
                <table>
                    <thead>
                        <tr>
                            <th>Program</th>
                            <th>Average Annual Tuition Fee (NZD)</th>
                            <th>Approx. INR</th>
                        </tr>
                    </thead>
                    <tr>
                        <td>Diploma/Certificate</td>
                        <td>10,000–18,000 </td>
                        <td>₹5–₹9 Lakhs</td>
                    </tr>
                    <tr>
                        <td>Bachelor's Degree</td>
                        <td>20,000–32,000</td>
                        <td>₹10–₹16 Lakhs</td>
                    </tr>
                    <tr>
                        <td>Graduate Diploma </td>
                        <td>19,000–25,000</td>
                        <td>₹9.5–₹12.5 Lakhs </td>
                    </tr>
                    <tr>
                        <td>Master’s Degree</td>
                        <td>26,000–40,000 </td>
                        <td>₹13–₹20 Lakhs </td>
                    </tr>
                    <tr>
                        <td>MBA/Executive Programs </td>
                        <td> 31,000–50,000</td>
                        <td>₹15.5–₹25 Lakhs </td>
                    </tr>
                    <tr>
                        <td>Ph.D. (Intl. Students)</td>
                        <td>6,500–9,000 </td>
                        <td>₹3.2–₹4.5 Lakhs</td>
                    </tr>
                </table>
            <hr/>
            <h2> Scholarships for International Students </h2>
             <table>
                <thead>
                    <tr>
                        <th>Scholarship</th>
                        <th>Offered By </th>
                        <th>Coverage</th>
                        <th>Eligibility</th>
                    </tr>
                </thead>
                <tr>
                    <td>New Zealand Govt. Scholarships </td>
                    <td>NZ Government</td>
                    <td>Full Tuition, Living Expenses</td>
                    <td>Academic Excellence, Leadership </td>
                </tr>
                <tr>
                    <td>University of Auckland Excellence Scholarship </td>
                    <td>UoA </td>
                    <td>Up to NZD 10,000</td>
                    <td>UG/PG High Achievers</td>
                </tr>
                <tr>
                    <td>Victoria Tongarewa Scholarship </td>
                    <td>Victoria University </td>
                    <td>NZD 5,000 - 10,000 </td>
                    <td>First-Year UG/PG Students</td>
                </tr>
                <tr>
                    <td>University of Otago International Master's Scholarship </td>
                    <td>Otago</td>
                    <td>NZD 10,000 Tuition Waiver </td>
                    <td>High-Performing PG Students </td>
                </tr>
                <tr>
                    <td>Lincoln University International Scholarship </td>
                    <td>Lincoln</td>
                    <td>Up to NZD 5,000 </td>
                    <td>UG/PG Applicants with High GPA </td>
                </tr>
                <tr>
                    <td>Commonwealth Scholarships</td>
                    <td>Commonwealth Fund </td>
                    <td>Full Funding </td>
                    <td>Indian & Other Commonwealth Nationals </td>
                </tr>
             </table>
    
             <hr />
             <h2>Popular Programs to Study in New Zealand </h2>
             <ul>
                <li>Business Administration (MBA) </li>
                <li>Computer Science and IT </li>
                <li>Engineering (Civil, Mechanical, Electrical) </li>
                <li>Tourism and Hospitality Management  </li>
                <li>Environmental Science  </li>
                <li>Biotechnology and Food Technology</li>
             </ul>
             <hr />
             <h2>New Zealand Study Visa Requirements</h2>
             <ul>
                <li>Valid Passport (minimum 3 months validity after course completion)</li>
                <li>Offer Letter from a Recognized Institution</li>
                <li>Proof of Sufficient Funds (Tuition + Living Costs) </li>
                <li>Health and Character Certificates</li>
                <li>SOP (Statement of Purpose) </li>
                <li>Academic and Work Experience Documents (if applicable)</li>
                <li>Visa Application Form and Visa Fees</li>
             </ul>
             <hr/>
             <h2>Work and PR Opportunities </h2>
             <ul>
                <li>Part-Time Work: 20 hours/week during semesters, full-time during vacations (NZ$22.70/hr minimum wage) </li>
                <li>Post-Study Work Visa: 1–3 years based on qualification level </li>
                <li>PR Pathways: Skills-shortage lists and Green List qualifications help in faster PR applications </li>
             </ul>
        </div>
        <TaskBar />
        <CopyRight />
        </>
    )

}

export default CountrieNez